import { PropsGrid } from './PropsGrid';
import classNames from 'classnames';

import styles from './Grid.module.scss';

export const Grid = ({ children, className, row, column, gap = '10px', jc, at, ...props }: PropsGrid): JSX.Element => {
  return (
    <div
      {...props}
      style={{ gap }}
      className={classNames(styles.Container, row && styles.Row, column && styles.Column, jc && styles.JC, at && styles.AT, className)}
    >
      {children}
    </div>
  );
};
